import { render, staticRenderFns } from "./ExpertTemplateProfile.vue?vue&type=template&id=1f34b88e&lang=pug"
import script from "./ExpertTemplateProfile.vue?vue&type=script&lang=ts"
export * from "./ExpertTemplateProfile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports